export default "__VITE_ASSET__CqHP6MPk__"